type BrandMarkProps = {
  compact?: boolean
  muted?: boolean
}

export function BrandMark({ compact = false, muted = false }: BrandMarkProps) {
  return (
    <span
      className={[
        'brand-mark',
        compact ? 'brand-mark--compact' : '',
        muted ? 'brand-mark--muted' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span className="brand-mark__icon">
        <img alt="" src="/assets/blastcore-icon.png" />
      </span>
      <span className="brand-mark__word">BlastCore</span>
    </span>
  )
}
